import { useCallback } from "react";
import biApi from "../../../../../../api/biApi.ts";
import type { BalanceSheetDataResponse, BuildBalanceSheetReportRequest } from "../../../../../../api/types/svTypes.ts";
import useFetch from "@entrilia/shared/hooks/useFetch.ts";

export default function useBalanceSheetData(request: BuildBalanceSheetReportRequest) {
  const loadBalanceSheet = useCallback(
    (signal?: AbortSignal) => {
      return biApi.buildBalanceSheetReport(request, signal);
    },
    [request]
  );

  const [data, error, { isFetching, fetch }] = useFetch<BalanceSheetDataResponse>(loadBalanceSheet);

  return {
    data,
    error,
    isFetching,
    refresh: fetch,
  };
}
